const getters = {
    id: state => state.user.id,
    name: state => state.user.name,
    icon: state => state.user.icon,

    bookName: state => state.author.bookName,
    isFree: state => state.author.isFree,
    sequence: state => state.author.sequence,

}
export default getters